// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.L5962tej9cStT7MAgD6U{background:var(--background-primary-inverted-primary);border-radius:32px;width:254px;height:486px;padding:8px;display:flex;box-shadow:inset 0 -2px 12px rgba(169,180,188,.6)}.bFMPi4pQSQtI1njsFTyo{border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary);border-radius:32px;flex-grow:1;display:flex;overflow:hidden}.cVon9QLyqQ4jng5jTgu4{border-radius:12px;flex-grow:1;display:flex;overflow:auto}.yufVHDAkMNImtvMFSkki{flex-direction:column;gap:8px;display:flex}.lssqAojB_z02dv1QsbbS{justify-content:flex-start;align-items:center;gap:6px;height:44px;display:flex}.Oz2Ftfeyj4PxNmMAlvJ9{padding:0 12px;box-shadow:0 1px 2px rgba(18,21,23,.12)}.dsK0zMQS6QwhWDGeswel{flex-direction:column;gap:8px;padding:12px;display:flex}.MrxG2DwsVAI4kCVdLebG{background:var(--background-brand-subtle-primary);color:var(--content-neutral-primary);border-radius:12px;max-width:200px;padding:12px}.HRhsy03x2f8bZd88ZeNZ{background:var(--background-neutral-default)}.Qi6l6ZR6UNES22UWnM38{width:186px;height:auto;padding:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preview": `L5962tej9cStT7MAgD6U`,
	"preview__layer": `bFMPi4pQSQtI1njsFTyo`,
	"previewLayer": `bFMPi4pQSQtI1njsFTyo`,
	"preview__layerWrap": `cVon9QLyqQ4jng5jTgu4`,
	"previewLayerWrap": `cVon9QLyqQ4jng5jTgu4`,
	"preview__content": `yufVHDAkMNImtvMFSkki`,
	"previewContent": `yufVHDAkMNImtvMFSkki`,
	"preview__header": `lssqAojB_z02dv1QsbbS`,
	"previewHeader": `lssqAojB_z02dv1QsbbS`,
	"preview__headerWrap": `Oz2Ftfeyj4PxNmMAlvJ9`,
	"previewHeaderWrap": `Oz2Ftfeyj4PxNmMAlvJ9`,
	"preview__messages": `dsK0zMQS6QwhWDGeswel`,
	"previewMessages": `dsK0zMQS6QwhWDGeswel`,
	"preview__message": `MrxG2DwsVAI4kCVdLebG`,
	"previewMessage": `MrxG2DwsVAI4kCVdLebG`,
	"preview__messageOutbound": `HRhsy03x2f8bZd88ZeNZ`,
	"previewMessageOutbound": `HRhsy03x2f8bZd88ZeNZ`,
	"preview__messageWithImage": `Qi6l6ZR6UNES22UWnM38`,
	"previewMessageWithImage": `Qi6l6ZR6UNES22UWnM38`
};
export default ___CSS_LOADER_EXPORT___;
